import { useRawAttributesStore } from '../stores/rawAttributesStore';

export const useRawAttributes = () => {
  const rawAttributes = useRawAttributesStore((state) => state.rawAttributes);
  const setRawAttributes = useRawAttributesStore(
    (state) => state.setRawAttributes
  );
  const clearRawAttributes = useRawAttributesStore(
    (state) => state.clearRawAttributes
  );
  const getRawAttributes = useRawAttributesStore(
    (state) => state.getRawAttributes
  );
  const isRawAttributesLoaded = useRawAttributesStore((state) =>
    state.isRawAttributesLoaded()
  );

  return {
    rawAttributes,
    isLoaded: isRawAttributesLoaded,
    setRawAttributes,
    clearRawAttributes,
    getRawAttributes,
  };
};
